import React from "react";
import Card from "react-bootstrap/Card";
import ShowMoreText from "react-show-more-text";
import projImg3 from "../../assets/img/3.png";
import projectimage3 from "../../assets/img/p3.png";

const PreviousCard3 = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Tournament Design</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage3} />

        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg3} />{" "}
            <p className="text7">László Csató </p>
            <br />
            <p className="text8">
              Research Fellow <br />
              Research Group of Operations Research and Decision Systems,
              SZTAKI
            </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
              Finding the optimal design of sports tournaments is an
              important question of scientific research. Organizers can
              choose several characteristics of a tournament, including
              its format, the schedule of individual matches, the seeding
              policy, or the ranking rules, subject to some constraints.
              In the analysis and comparison of different tournament
              designs, both theoretical and simulation tools can be
              successfully applied.
              <br />
              <br />
              Related literature:{" "}
              <ul>
                <li>
                  Csató, L. (2021).
                  <span className="text9">
                    {" "}
                    Tournament Design: How Operations Research Can Improve
                    Sports Rules
                  </span>
                  . Palgrave Pivots in Sports Economics. Palgrave
                  Macmillan, Cham, Switzerland.
                </li>
                <li>
                  Kendall, G. and Lenten, L. J. A. (2017). When sports
                  rules go awry.
                  <span className="text9">
                    {" "}
                    European Journal of Operational Research{" "}
                  </span>
                  , 257(2):377–394.
                </li>
                <li>
                  Lenten, L. J. A. and Kendall, G. (2021). Scholarly
                  sports: Influence of social science academe on sports
                  rules and policy.
                  <span className="text9">
                    {" "}
                    Journal of the Operational Research Society{" "}
                  </span>
                  , in press. DOI: 10.1080/01605682.2021.2000896.
                </li>
                <li>
                  {" "}
                  Wright, M. (2009). 50 years of OR in sport.
                  <span className="text9">
                    Journal of the Operational Research Society{" "}
                  </span>{" "}
                  , 60(Supplement 1):S161–S168.{" "}
                </li>
                <li>
                  Wright, M. (2014). OR analysis of sporting rules – A
                  survey.
                  <span className="text9">
                    {" "}
                    European Journal of Operational Research{" "}
                  </span>
                  , 232(1):1–8.
                </li>
              </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default PreviousCard3;
